import type { NotificationVisualMessage } from '@/service/api/endpoints/notificacoes'

type Modo = NotificationVisualMessage['mode'][number]

/** Seleciona o modo mais forte para registrar a ciência da campanha. */
export function modoCiencia(modos: Modo[]): Modo {
    if (modos.includes('modal')) return 'modal'
    if (modos.includes('badge')) return 'badge'

    return 'toast'
}
